var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"pa-4",attrs:{"data-qa":"contactus-flex-wbu1op"}},[_vm._v(" "+_vm._s('Contact Us')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }